import React, { useState } from 'react';
import {
    Box,
    VStack,
    Heading,
    Text,
    Container,
    Icon,
    useColorModeValue,
    useBreakpointValue,
    Button,
    Input,
    FormControl,
    FormLabel,
    FormHelperText,
    useToast,
    Image,
    HStack,
    Link as ChakraLink,
    SimpleGrid,
    Badge,
    Textarea,
    Divider,
    IconButton,
    Flex,
    Collapse,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    List,
    ListItem,
    ListIcon,
    Tooltip,
    Select,
    InputGroup,
    InputLeftElement,
    ModalFooter
} from '@chakra-ui/react';
import { FaQrcode, FaArrowLeft, FaDownload, FaShoppingCart, FaPlus, FaTrash, FaBox, FaInfoCircle, FaCheckCircle, FaSearchPlus } from 'react-icons/fa';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

// Import images
import qrSticker50 from '../assets/qrSticker/qrStickerPackOf50.png';
import qrSticker100 from '../assets/qrSticker/qrStickerPackOf100.png';
import qrSticker150 from '../assets/qrSticker/qrStickerPackOf150.png';
import qrSticker200 from '../assets/qrSticker/qrStickerPackOf200.png';
import qrSticker250 from '../assets/qrSticker/qrStickerPackOf250.png';
import tentMenu25 from '../assets/tentMenu/tentMenuPackOf25.png';
import tentMenu50 from '../assets/tentMenu/tentMenuPackOf50.png';
import tentMenu100 from '../assets/tentMenu/tentMenuPackOf100.png';
import tentMenu250 from '../assets/tentMenu/tentMenuPackOf250.png';
import tentMenu500 from '../assets/tentMenu/tentMenuPackOf500.png';

const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_BASE_URL_DEV : process.env.REACT_APP_API_BASE_URL_PROD;

// Country codes data
const COUNTRIES = [
    { code: '+1', name: 'United States', flag: '🇺🇸', length: 10 },
    { code: '+1', name: 'Canada', flag: '🇨🇦', length: 10 },
    { code: '+44', name: 'United Kingdom', flag: '🇬🇧', length: 10 },
    { code: '+91', name: 'India', flag: '🇮🇳', length: 10 },
    { code: '+61', name: 'Australia', flag: '🇦🇺', length: 9 },
    { code: '+81', name: 'Japan', flag: '🇯🇵', length: 10 },
    { code: '+86', name: 'China', flag: '🇨🇳', length: 11 },
    { code: '+49', name: 'Germany', flag: '🇩🇪', length: 10 },
    { code: '+33', name: 'France', flag: '🇫🇷', length: 9 },
    { code: '+39', name: 'Italy', flag: '🇮🇹', length: 10 },
    { code: '+34', name: 'Spain', flag: '🇪🇸', length: 9 },
    { code: '+7', name: 'Russia', flag: '🇷🇺', length: 10 },
    { code: '+55', name: 'Brazil', flag: '🇧🇷', length: 11 },
    { code: '+52', name: 'Mexico', flag: '🇲🇽', length: 10 },
    { code: '+27', name: 'South Africa', flag: '🇿🇦', length: 9 },
    { code: '+20', name: 'Egypt', flag: '🇪🇬', length: 10 },
    { code: '+234', name: 'Nigeria', flag: '🇳🇬', length: 10 },
    { code: '+254', name: 'Kenya', flag: '🇰🇪', length: 9 },
    { code: '+971', name: 'UAE', flag: '🇦🇪', length: 9 },
    { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦', length: 9 },
    { code: '+65', name: 'Singapore', flag: '🇸🇬', length: 8 },
    { code: '+60', name: 'Malaysia', flag: '🇲🇾', length: 9 },
    { code: '+62', name: 'Indonesia', flag: '🇮🇩', length: 10 },
    { code: '+63', name: 'Philippines', flag: '🇵🇭', length: 10 },
    { code: '+66', name: 'Thailand', flag: '🇹🇭', length: 9 },
    { code: '+84', name: 'Vietnam', flag: '🇻🇳', length: 9 },
    { code: '+82', name: 'South Korea', flag: '🇰🇷', length: 10 },
    { code: '+92', name: 'Pakistan', flag: '🇵🇰', length: 10 },
    { code: '+880', name: 'Bangladesh', flag: '🇧🇩', length: 10 },
    { code: '+94', name: 'Sri Lanka', flag: '🇱🇰', length: 9 },
    { code: '+977', name: 'Nepal', flag: '🇳🇵', length: 10 },
    { code: '+64', name: 'New Zealand', flag: '🇳🇿', length: 9 },
    { code: '+351', name: 'Portugal', flag: '🇵🇹', length: 9 },
    { code: '+31', name: 'Netherlands', flag: '🇳🇱', length: 9 },
    { code: '+32', name: 'Belgium', flag: '🇧🇪', length: 9 },
    { code: '+41', name: 'Switzerland', flag: '🇨🇭', length: 9 },
    { code: '+43', name: 'Austria', flag: '🇦🇹', length: 10 },
    { code: '+45', name: 'Denmark', flag: '🇩🇰', length: 8 },
    { code: '+46', name: 'Sweden', flag: '🇸🇪', length: 9 },
    { code: '+47', name: 'Norway', flag: '🇳🇴', length: 8 },
    { code: '+358', name: 'Finland', flag: '🇫🇮', length: 9 },
    { code: '+48', name: 'Poland', flag: '🇵🇱', length: 9 },
    { code: '+420', name: 'Czech Republic', flag: '🇨🇿', length: 9 },
    { code: '+36', name: 'Hungary', flag: '🇭🇺', length: 9 },
    { code: '+30', name: 'Greece', flag: '🇬🇷', length: 10 },
    { code: '+90', name: 'Turkey', flag: '🇹🇷', length: 10 },
    { code: '+98', name: 'Iran', flag: '🇮🇷', length: 10 },
    { code: '+972', name: 'Israel', flag: '🇮🇱', length: 9 },
    { code: '+56', name: 'Chile', flag: '🇨🇱', length: 9 },
    { code: '+54', name: 'Argentina', flag: '🇦🇷', length: 10 },
    { code: '+57', name: 'Colombia', flag: '🇨🇴', length: 10 },
    { code: '+51', name: 'Peru', flag: '🇵🇪', length: 9 },
    { code: '+58', name: 'Venezuela', flag: '🇻🇪', length: 10 },
];

// Product catalog with images
const PRODUCTS = {
    'tent-card': [
        { quantity: 25, price: 'USD 5.60 (INR 500)', description: 'Perfect for small setups', image: tentMenu25 },
        { quantity: 50, price: 'USD 11.16 (INR 1000)', description: 'Great for medium restaurants', image: tentMenu50 },
        { quantity: 100, price: 'USD 16.74 (INR 1500)', description: 'Popular choice', image: tentMenu100 },
        { quantity: 250, price: 'USD 30.13 (INR 2700)', description: 'Best value for money', image: tentMenu250 },
        { quantity: 500, price: 'USD 51.00 (INR 4500)', description: 'Bulk order discount', image: tentMenu500 }
    ],
    'qr-sticker': [
        { quantity: 50, price: 'USD 3.91 (INR 350)', description: 'Starter pack', image: qrSticker50 },
        { quantity: 100, price: 'USD 5.58 (INR 500)', description: 'Essential pack', image: qrSticker100 },
        { quantity: 150, price: 'USD 7.81 (INR 700)', description: 'Popular choice', image: qrSticker150 },
        { quantity: 200, price: 'USD 9.48 (INR 850)', description: 'Premium pack', image: qrSticker200 },
        { quantity: 250, price: 'USD 11.16 (INR 1000)', description: 'Bulk order discount', image: qrSticker250 }
    ]
};

function GenerateQR() {
    const [searchParams] = useSearchParams();
    const [subdomain, setSubdomain] = useState(searchParams.get('subdomain') || '');
    const [loading, setLoading] = useState(false);
    const [qrImage, setQrImage] = useState(null);
    const [showProducts, setShowProducts] = useState(false);
    
    // Cart and order details
    const [cart, setCart] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [shippingAddress, setShippingAddress] = useState('');
    const [orderLoading, setOrderLoading] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(COUNTRIES.find(c => c.code === '+91')); // Default to India

    // Modals
    const { isOpen: isHowItWorksOpen, onOpen: onHowItWorksOpen, onClose: onHowItWorksClose } = useDisclosure();
    const { isOpen: isImageModalOpen, onOpen: onImageModalOpen, onClose: onImageModalClose } = useDisclosure();
    const { isOpen: isCartModalOpen, onOpen: onCartModalOpen, onClose: onCartModalClose } = useDisclosure();
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageTitle, setSelectedImageTitle] = useState('');

    const toast = useToast();

    const bgColor = useColorModeValue('#fafaf7', 'gray.800');
    const textColor = useColorModeValue('gray.800', 'gray.100');
    const accentColor = useColorModeValue('yellow.400', 'yellow.300');
    const cardBgColor = useColorModeValue('white', 'gray.700');

    const headingSize = useBreakpointValue({ base: '2xl', md: '3xl', lg: '4xl' });
    const subHeadingSize = useBreakpointValue({ base: 'md', md: 'lg' });

    const handleGenerateQR = async () => {
        if (!subdomain.trim()) {
            toast({
                title: 'Subdomain required',
                description: 'Please enter a subdomain',
                status: 'warning',
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        // Validate subdomain format
        const subdomainRegex = /^[a-z0-9-]+$/;
        if (!subdomainRegex.test(subdomain)) {
            toast({
                title: 'Invalid subdomain',
                description: 'Subdomain can only contain lowercase letters, numbers, and hyphens',
                status: 'error',
                duration: 4000,
                isClosable: true,
            });
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/landingAuth/generate-a-qr`,
                { subdomain },
                { responseType: 'blob' }
            );

            // Create a URL for the blob
            const imageUrl = URL.createObjectURL(response.data);
            setQrImage(imageUrl);
            setShowProducts(true);

            toast({
                title: 'QR Code generated!',
                description: 'Your QR code is ready. Browse products below!',
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            console.error('Error generating QR:', error);
            toast({
                title: 'Generation failed',
                description: error.response?.data?.error || 'Failed to generate QR code. Please try again.',
                status: 'error',
                duration: 4000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = () => {
        if (!qrImage) return;

        const link = document.createElement('a');
        link.href = qrImage;
        link.download = `${subdomain}-qr.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast({
            title: 'Downloaded!',
            description: 'QR code saved to your device',
            status: 'success',
            duration: 2000,
            isClosable: true,
        });
    };

    const addToCart = (productType, quantity, image) => {
        // Check if product already in cart
        const existingIndex = cart.findIndex(
            item => item.productType === productType && item.quantity === quantity
        );

        if (existingIndex !== -1) {
            toast({
                title: 'Already in cart',
                description: 'This item is already in your cart',
                status: 'info',
                duration: 2000,
                isClosable: true,
            });
            return;
        }

        setCart([...cart, { productType, quantity, image }]);
        toast({
            title: 'Added to cart!',
            status: 'success',
            duration: 1500,
            isClosable: true,
        });
    };

    const removeFromCart = (index) => {
        setCart(cart.filter((_, i) => i !== index));
    };

    const handleCountryChange = (e) => {
        const countryIndex = parseInt(e.target.value);
        setSelectedCountry(COUNTRIES[countryIndex]);
        // Clear phone number when country changes
        setPhoneNumber('');
    };

    const handlePhoneNumberChange = (e) => {
        // Remove all non-digits
        let formattedValue = e.target.value.replace(/\D/g, '');

        // Limit based on selected country's expected length
        const maxLength = selectedCountry?.length || 15;
        if (formattedValue.length > maxLength) {
            formattedValue = formattedValue.substring(0, maxLength);
        }

        setPhoneNumber(formattedValue);
    };

    const handlePlaceOrder = async () => {
        // Validation
        if (cart.length === 0) {
            toast({
                title: 'Cart is empty',
                description: 'Please add at least one product to your cart',
                status: 'warning',
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (!phoneNumber.trim()) {
            toast({
                title: 'Phone number required',
                description: 'Please enter your phone number',
                status: 'warning',
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        // Validate phone number based on selected country
        const expectedLength = selectedCountry.length;
        if (phoneNumber.length < expectedLength - 2 || phoneNumber.length > expectedLength + 2) {
            toast({
                title: 'Invalid phone number',
                description: `Please enter a valid phone number for ${selectedCountry.name} (typically ${expectedLength} digits)`,
                status: 'warning',
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        if (!shippingAddress.trim()) {
            toast({
                title: 'Shipping address required',
                description: 'Please enter your shipping address',
                status: 'warning',
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setOrderLoading(true);

        try {
            // Format phone number with country code
            const fullPhoneNumber = `${selectedCountry.code}${phoneNumber}`;

            // eslint-disable-next-line
            const response = await axios.post(
                `${API_BASE_URL}/api/landingAuth/place-qr-order`,
                {
                    subdomain,
                    phoneNumber: fullPhoneNumber,
                    shippingAddress,
                    products: cart.map(item => ({ productType: item.productType, quantity: item.quantity }))
                }
            );

            toast({
                title: 'Order placed successfully!',
                description: 'Check your email for payment links',
                status: 'success',
                duration: 5000,
                isClosable: true,
            });

            // Reset cart and form
            setCart([]);
            setPhoneNumber('');
            setShippingAddress('');
            onCartModalClose();

        } catch (error) {
            console.error('Error placing order:', error);
            toast({
                title: 'Order failed',
                description: error.response?.data?.message || 'Failed to place order. Please try again.',
                status: 'error',
                duration: 4000,
                isClosable: true,
            });
        } finally {
            setOrderLoading(false);
        }
    };

    const getProductDisplayName = (productType) => {
        return productType === 'qr-sticker' ? 'QR Stickers' : 'Tent Cards';
    };

    const handleReset = () => {
        setSubdomain('');
        setQrImage(null);
        setShowProducts(false);
        setCart([]);
        setPhoneNumber('');
        setShippingAddress('');
    };

    const handleImageClick = (image, title) => {
        setSelectedImage(image);
        setSelectedImageTitle(title);
        onImageModalOpen();
    };

    return (
        <Box minH="100vh" position="relative" overflow="hidden" bg={bgColor}>
            {/* Back to Home Button */}
            <Box
                position="absolute"
                top={{ base: 4, md: 6 }}
                left={{ base: 4, md: 6 }}
                zIndex="10"
            >
                <Button
                    as={Link}
                    to="/"
                    variant="ghost"
                    leftIcon={<FaArrowLeft />}
                    size={{ base: 'sm', md: 'md' }}
                    color={textColor}
                    _hover={{ bg: 'blackAlpha.100', transform: 'translateX(-2px)' }}
                    transition="all 0.2s"
                    fontWeight="medium"
                >
                    Home
                </Button>
            </Box>

            {/* Floating Cart Widget */}
            {cart.length > 0 && (
                <Box
                    position="fixed"
                    bottom={{ base: 4, md: 6 }}
                    right={{ base: 4, md: 6 }}
                    zIndex="100"
                >
                    <Tooltip label="View Cart" fontSize="sm">
                        <Button
                            onClick={onCartModalOpen}
                            size="lg"
                            bg="orange.400"
                            color="white"
                            _hover={{ bg: 'orange.500', transform: 'scale(1.05)' }}
                            _active={{ bg: 'orange.600' }}
                            boxShadow="2xl"
                            borderRadius="full"
                            height={{ base: '60px', md: '70px' }}
                            width={{ base: '60px', md: '70px' }}
                            position="relative"
                            transition="all 0.3s ease"
                        >
                            <Icon as={FaShoppingCart} boxSize={{ base: 6, md: 7 }} />
                            <Badge
                                position="absolute"
                                top="-2"
                                right="-2"
                                colorScheme="red"
                                borderRadius="full"
                                fontSize="sm"
                                minW="24px"
                                height="24px"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                {cart.length}
                            </Badge>
                        </Button>
                    </Tooltip>
                </Box>
            )}

            {/* Decorative Elements */}
            <Box
                display={{ base: 'block', md: 'none' }}
                position="absolute"
                top="8%"
                right="5%"
                w="50px"
                h="50px"
                bg={accentColor}
                borderRadius="50%"
                opacity="0.6"
                zIndex="0"
                animation="bounce 3s ease-in-out infinite"
                sx={{
                    '@keyframes bounce': {
                        '0%, 100%': { transform: 'translateY(0px)' },
                        '50%': { transform: 'translateY(-10px)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', md: 'block' }}
                position="absolute"
                top="15%"
                left="10%"
                w="180px"
                h="180px"
                bg={accentColor}
                borderRadius="50% 40% 60% 30%"
                opacity="0.5"
                zIndex="0"
                animation="float 6s ease-in-out infinite"
                sx={{
                    '@keyframes float': {
                        '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
                        '50%': { transform: 'translateY(-20px) rotate(5deg)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', md: 'block' }}
                position="absolute"
                bottom="15%"
                right="12%"
                w="140px"
                h="140px"
                bg="orange.300"
                borderRadius="40% 60% 30% 70%"
                opacity="0.6"
                zIndex="0"
                animation="pulse 5s ease-in-out infinite"
                sx={{
                    '@keyframes pulse': {
                        '0%, 100%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.1)' }
                    }
                }}
            />

            {/* Main Content */}
            <Container
                maxW="7xl"
                position="relative"
                zIndex="1"
                minH="100vh"
                py={{ base: 16, md: 8 }}
                px={{ base: 4, md: 6 }}
            >
                <VStack spacing={{ base: 8, md: 10 }} textAlign="center" w="full">
                    {/* QR Icon */}
                    <Box position="relative">
                        <Icon
                            as={FaQrcode}
                            boxSize={{ base: '16', md: '20', lg: '24' }}
                            color={accentColor}
                        />
                    </Box>

                    {/* Heading */}
                    <VStack spacing={{ base: 3, md: 4 }}>
                        <Heading
                            as="h1"
                            size={headingSize}
                            color={textColor}
                            fontWeight="bold"
                            lineHeight="1.2"
                        >
                            Generate QR & Order Products
                        </Heading>

                        <Text
                            fontSize={subHeadingSize}
                            color="gray.600"
                            fontWeight="medium"
                            lineHeight="1.6"
                            maxW="2xl"
                        >
                            Create a custom QR code and order physical products for your restaurant
                        </Text>
                    </VStack>

                    {/* Generator Card */}
                    <Box
                        bg={cardBgColor}
                        p={{ base: 6, md: 8 }}
                        borderRadius="2xl"
                        border="2px solid"
                        borderColor={accentColor}
                        boxShadow="xl"
                        maxW="2xl"
                        w="full"
                        position="relative"
                        overflow="hidden"
                    >
                        <VStack spacing={6}>
                            {!qrImage ? (
                                <>
                                    <FormControl>
                                        <FormLabel fontSize="md" fontWeight="bold" color={textColor}>
                                            Enter your subdomain
                                        </FormLabel>
                                        <HStack spacing={2}>
                                            <Input
                                                placeholder="sample"
                                                value={subdomain}
                                                onChange={(e) => setSubdomain(e.target.value.toLowerCase())}
                                                size="lg"
                                                borderColor="gray.300"
                                                _hover={{ borderColor: 'gray.400' }}
                                                _focus={{ borderColor: accentColor, boxShadow: `0 0 0 1px ${accentColor}` }}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleGenerateQR();
                                                    }
                                                }}
                                            />
                                            <Text fontSize="lg" color="gray.600" fontWeight="medium" whiteSpace="nowrap">
                                                .piepos.in
                                            </Text>
                                        </HStack>
                                        <FormHelperText>
                                            Only lowercase letters, numbers, and hyphens allowed
                                        </FormHelperText>
                                    </FormControl>

                                    <HStack spacing={3} w="full">
                                        <Button
                                            onClick={handleGenerateQR}
                                            isLoading={loading}
                                            loadingText="Generating..."
                                            size="lg"
                                            bg={accentColor}
                                            color="gray.900"
                                            _hover={{ bg: 'yellow.500', transform: 'translateY(-2px)' }}
                                            _active={{ bg: 'yellow.600' }}
                                            flex={1}
                                            borderRadius="lg"
                                            fontWeight="bold"
                                            boxShadow="md"
                                            transition="all 0.3s ease"
                                            leftIcon={<FaQrcode />}
                                        >
                                            Generate QR
                                        </Button>
                                        <Tooltip label="Learn how this works" fontSize="sm">
                                            <IconButton
                                                onClick={onHowItWorksOpen}
                                                size="lg"
                                                variant="outline"
                                                colorScheme="blue"
                                                icon={<FaInfoCircle />}
                                                aria-label="Learn how this works"
                                            />
                                        </Tooltip>
                                    </HStack>
                                </>
                            ) : (
                                <>
                                    <Box
                                        border="3px solid"
                                        borderColor="gray.200"
                                        borderRadius="xl"
                                        overflow="hidden"
                                        bg="white"
                                    >
                                        <Image
                                            src={qrImage}
                                            alt="Generated QR Code"
                                            maxW="full"
                                            h="auto"
                                        />
                                    </Box>

                                    <HStack spacing={3} w="full">
                                        <Button
                                            onClick={handleDownload}
                                            size="lg"
                                            bg={accentColor}
                                            color="gray.900"
                                            _hover={{ bg: 'yellow.500' }}
                                            flex={1}
                                            leftIcon={<FaDownload />}
                                            fontWeight="bold"
                                        >
                                            Download
                                        </Button>
                                        <Button
                                            onClick={handleReset}
                                            size="lg"
                                            variant="outline"
                                            colorScheme="gray"
                                            flex={1}
                                            fontWeight="bold"
                                        >
                                            Start Over
                                        </Button>
                                    </HStack>

                                    <Text fontSize="sm" color="gray.500">
                                        QR code for{' '}
                                        <Text as="span" fontWeight="bold" color={textColor}>
                                            {subdomain}.piepos.in
                                        </Text>
                                    </Text>
                                </>
                            )}
                        </VStack>
                    </Box>

                    {/* Products Section */}
                    <Collapse in={showProducts} animateOpacity style={{ width: '100%' }}>
                        <VStack spacing={8} w="full" mt={8}>
                            {/* Product Categories */}
                            <VStack spacing={8} w="full">
                                {/* QR Stickers */}
                                <Box w="full">
                                    <VStack spacing={4}>
                                        <HStack>
                                            <Icon as={FaQrcode} color={accentColor} boxSize={6} />
                                            <Heading size="lg" color={textColor}>
                                                QR Stickers
                                            </Heading>
                                        </HStack>
                                        <Text fontSize="md" color="gray.600" textAlign="center">
                                            Waterproof, durable stickers for tables and surfaces
                                        </Text>

                                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4} w="full">
                                            {PRODUCTS['qr-sticker'].map((product) => (
                                                <Box
                                                    key={product.quantity}
                                                    bg={cardBgColor}
                                                    p={5}
                                                    borderRadius="xl"
                                                    border="2px solid"
                                                    borderColor="gray.200"
                                                    boxShadow="md"
                                                    _hover={{
                                                        transform: 'translateY(-4px)',
                                                        boxShadow: 'lg',
                                                        borderColor: accentColor
                                                    }}
                                                    transition="all 0.3s ease"
                                                >
                                                    <VStack spacing={3}>
                                                        <Badge colorScheme="yellow" fontSize="xs">
                                                            QR Sticker
                                                        </Badge>

                                                        {/* Product Image */}
                                                        <Box position="relative" w="full">
                                                            <Image
                                                                src={product.image}
                                                                alt={`QR Sticker Pack of ${product.quantity}`}
                                                                borderRadius="md"
                                                                w="full"
                                                                h="200px"
                                                                objectFit="cover"
                                                            />
                                                            <IconButton
                                                                icon={<FaSearchPlus />}
                                                                size="sm"
                                                                position="absolute"
                                                                top={2}
                                                                right={2}
                                                                colorScheme="blackAlpha"
                                                                onClick={() => handleImageClick(product.image, `QR Sticker Pack of ${product.quantity}`)}
                                                                aria-label="View full image"
                                                            />
                                                        </Box>

                                                        <Heading size="xl" color={textColor}>
                                                            {product.quantity}
                                                        </Heading>
                                                        <Text fontSize="sm" color="gray.600">
                                                            pieces
                                                        </Text>
                                                        <Text fontSize="lg" fontWeight="bold" color="green.600">
                                                            {product.price}
                                                        </Text>
                                                        <Text fontSize="xs" color="gray.500" textAlign="center">
                                                            {product.description}
                                                        </Text>
                                                        <Button
                                                            onClick={() => addToCart('qr-sticker', product.quantity, product.image)}
                                                            size="sm"
                                                            bg={accentColor}
                                                            color="gray.900"
                                                            _hover={{ bg: 'yellow.500' }}
                                                            leftIcon={<FaPlus />}
                                                            fontWeight="bold"
                                                            w="full"
                                                        >
                                                            Add to Cart
                                                        </Button>
                                                    </VStack>
                                                </Box>
                                            ))}
                                        </SimpleGrid>
                                    </VStack>
                                </Box>

                                <Divider />

                                {/* Tent Cards */}
                                <Box w="full">
                                    <VStack spacing={4}>
                                        <HStack>
                                            <Icon as={FaBox} color="orange.400" boxSize={6} />
                                            <Heading size="lg" color={textColor}>
                                                Custom Tent Cards
                                            </Heading>
                                        </HStack>
                                        <Text fontSize="md" color="gray.600" textAlign="center">
                                            Premium table tent cards with your custom menu
                                        </Text>

                                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4} w="full">
                                            {PRODUCTS['tent-card'].map((product) => (
                                                <Box
                                                    key={product.quantity}
                                                    bg={cardBgColor}
                                                    p={5}
                                                    borderRadius="xl"
                                                    border="2px solid"
                                                    borderColor="gray.200"
                                                    boxShadow="md"
                                                    _hover={{
                                                        transform: 'translateY(-4px)',
                                                        boxShadow: 'lg',
                                                        borderColor: 'orange.300'
                                                    }}
                                                    transition="all 0.3s ease"
                                                >
                                                    <VStack spacing={3}>
                                                        <Badge colorScheme="orange" fontSize="xs">
                                                            Tent Card
                                                        </Badge>

                                                        {/* Product Image */}
                                                        <Box position="relative" w="full">
                                                            <Image
                                                                src={product.image}
                                                                alt={`Tent Card Pack of ${product.quantity}`}
                                                                borderRadius="md"
                                                                w="full"
                                                                h="200px"
                                                                objectFit="cover"
                                                            />
                                                            <IconButton
                                                                icon={<FaSearchPlus />}
                                                                size="sm"
                                                                position="absolute"
                                                                top={2}
                                                                right={2}
                                                                colorScheme="blackAlpha"
                                                                onClick={() => handleImageClick(product.image, `Tent Card Pack of ${product.quantity}`)}
                                                                aria-label="View full image"
                                                            />
                                                        </Box>

                                                        <Heading size="xl" color={textColor}>
                                                            {product.quantity}
                                                        </Heading>
                                                        <Text fontSize="sm" color="gray.600">
                                                            pieces
                                                        </Text>
                                                        <Text fontSize="lg" fontWeight="bold" color="green.600">
                                                            {product.price}
                                                        </Text>
                                                        <Text fontSize="xs" color="gray.500" textAlign="center">
                                                            {product.description}
                                                        </Text>
                                                        <Button
                                                            onClick={() => addToCart('tent-card', product.quantity, product.image)}
                                                            size="sm"
                                                            bg="orange.400"
                                                            color="white"
                                                            _hover={{ bg: 'orange.500' }}
                                                            leftIcon={<FaPlus />}
                                                            fontWeight="bold"
                                                            w="full"
                                                        >
                                                            Add to Cart
                                                        </Button>
                                                    </VStack>
                                                </Box>
                                            ))}
                                        </SimpleGrid>
                                    </VStack>
                                </Box>
                            </VStack>
                        </VStack>
                    </Collapse>

                    {/* Help Link */}
                    <Text fontSize="xs" color="gray.500">
                        Need help?{' '}
                        <ChakraLink
                            href="mailto:sankalp@piepos.in?subject=QR Code Feature Inquiry"
                            color="blue.500"
                            fontWeight="bold"
                            _hover={{ color: 'blue.600', textDecoration: 'underline' }}
                        >
                            Contact us
                        </ChakraLink>
                    </Text>
                </VStack>
            </Container>

            {/* Cart Modal */}
            <Modal isOpen={isCartModalOpen} onClose={onCartModalClose} size="xl" scrollBehavior="inside">
                <ModalOverlay backdropFilter="blur(4px)" />
                <ModalContent>
                    <ModalHeader>
                        <HStack>
                            <Icon as={FaShoppingCart} color="orange.500" />
                            <Text>Your Cart ({cart.length} {cart.length === 1 ? 'item' : 'items'})</Text>
                        </HStack>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack spacing={6} align="stretch">
                            {/* Cart Items */}
                            <VStack spacing={3} align="stretch">
                                <Heading size="sm" color={textColor}>
                                    Cart Items
                                </Heading>
                                <Divider />
                                {cart.map((item, index) => (
                                    <Flex
                                        key={index}
                                        justify="space-between"
                                        align="center"
                                        p={3}
                                        bg="orange.50"
                                        borderRadius="lg"
                                    >
                                        <HStack spacing={3}>
                                            <Image
                                                src={item.image}
                                                alt={getProductDisplayName(item.productType)}
                                                boxSize="50px"
                                                objectFit="cover"
                                                borderRadius="md"
                                            />
                                            <VStack align="start" spacing={0}>
                                                <Text fontWeight="bold" color={textColor}>
                                                    {getProductDisplayName(item.productType)}
                                                </Text>
                                                <Text fontSize="sm" color="gray.600">
                                                    Quantity: {item.quantity} pieces
                                                </Text>
                                            </VStack>
                                        </HStack>
                                        <IconButton
                                            icon={<FaTrash />}
                                            size="sm"
                                            colorScheme="red"
                                            variant="ghost"
                                            onClick={() => removeFromCart(index)}
                                            aria-label="Remove from cart"
                                        />
                                    </Flex>
                                ))}
                            </VStack>

                            <Divider />

                            {/* Shipping Details Form */}
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color={textColor}>
                                    Shipping Details
                                </Heading>

                                <FormControl isRequired>
                                    <FormLabel fontSize="sm" fontWeight="medium" color={textColor}>
                                        Country
                                    </FormLabel>
                                    <Select
                                        value={COUNTRIES.findIndex(c => c.code === selectedCountry?.code && c.name === selectedCountry?.name)}
                                        onChange={handleCountryChange}
                                        borderRadius="md"
                                        focusBorderColor="orange.400"
                                        borderColor="gray.300"
                                        color="gray.600"
                                        size="sm"
                                        fontSize="sm"
                                    >
                                        {COUNTRIES.map((country, index) => (
                                            <option key={index} value={index}>
                                                {country.flag} {country.name} ({country.code})
                                            </option>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontSize="sm" fontWeight="medium" color={textColor}>
                                        Phone Number
                                    </FormLabel>
                                    <InputGroup>
                                        <InputLeftElement
                                            pointerEvents="none"
                                            children={
                                                <Text fontSize="sm" color="gray.500" fontWeight="medium">
                                                    {selectedCountry?.code}
                                                </Text>
                                            }
                                            width="4rem"
                                        />
                                        <Input
                                            type="tel"
                                            placeholder={`${'0'.repeat(selectedCountry?.length || 10)}`}
                                            value={phoneNumber}
                                            onChange={handlePhoneNumberChange}
                                            size="md"
                                            borderColor="gray.300"
                                            _hover={{ borderColor: 'gray.400' }}
                                            _focus={{ borderColor: 'orange.400' }}
                                            paddingLeft="4.5rem"
                                        />
                                    </InputGroup>
                                    <Text fontSize="xs" color="gray.500" mt={1}>
                                        {selectedCountry?.name} phone number ({selectedCountry?.length} digits)
                                    </Text>
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontSize="sm" fontWeight="medium" color={textColor}>
                                        Shipping Address
                                    </FormLabel>
                                    <Textarea
                                        placeholder="Enter your complete shipping address"
                                        value={shippingAddress}
                                        onChange={(e) => setShippingAddress(e.target.value)}
                                        rows={3}
                                        borderColor="gray.300"
                                        _hover={{ borderColor: 'gray.400' }}
                                        _focus={{ borderColor: 'orange.400' }}
                                    />
                                </FormControl>
                            </VStack>
                        </VStack>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={handlePlaceOrder}
                            isLoading={orderLoading}
                            loadingText="Placing Order..."
                            size="lg"
                            bg="orange.400"
                            color="white"
                            _hover={{ bg: 'orange.500' }}
                            _active={{ bg: 'orange.600' }}
                            fontWeight="bold"
                            leftIcon={<FaBox />}
                            w="full"
                        >
                            Place Order ({cart.length} {cart.length === 1 ? 'item' : 'items'})
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* How It Works Modal */}
            <Modal isOpen={isHowItWorksOpen} onClose={onHowItWorksClose} size="xl">
                <ModalOverlay backdropFilter="blur(4px)" />
                <ModalContent>
                    <ModalHeader>
                        <HStack>
                            <Icon as={FaInfoCircle} color="blue.500" />
                            <Text>How Does This Work?</Text>
                        </HStack>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <VStack spacing={4} align="stretch">
                            <Text fontSize="md" color="gray.600">
                                Follow these simple steps to get your custom QR codes and products:
                            </Text>

                            <List spacing={4}>
                                <ListItem>
                                    <HStack align="start">
                                        <ListIcon as={FaCheckCircle} color="green.500" mt={1} />
                                        <VStack align="start" spacing={1}>
                                            <Text fontWeight="bold">Step 1: Enter Your Subdomain</Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Type in your restaurant's subdomain (e.g., "myrestaurant" for myrestaurant.piepos.in)
                                            </Text>
                                        </VStack>
                                    </HStack>
                                </ListItem>

                                <ListItem>
                                    <HStack align="start">
                                        <ListIcon as={FaCheckCircle} color="green.500" mt={1} />
                                        <VStack align="start" spacing={1}>
                                            <Text fontWeight="bold">Step 2: Generate Your QR Code</Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Click "Generate QR" to create your unique QR code that links to your digital menu
                                            </Text>
                                        </VStack>
                                    </HStack>
                                </ListItem>

                                <ListItem>
                                    <HStack align="start">
                                        <ListIcon as={FaCheckCircle} color="green.500" mt={1} />
                                        <VStack align="start" spacing={1}>
                                            <Text fontWeight="bold">Step 3: Download (Optional)</Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Download the QR code image for free. You can print it yourself or get it laminated locally
                                            </Text>
                                        </VStack>
                                    </HStack>
                                </ListItem>

                                <ListItem>
                                    <HStack align="start">
                                        <ListIcon as={FaCheckCircle} color="yellow.500" mt={1} />
                                        <VStack align="start" spacing={1}>
                                            <Text fontWeight="bold">Step 4: Or Order Professional Products</Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Browse our QR stickers and tent cards below. Add items to cart and place an order for professional quality products
                                            </Text>
                                        </VStack>
                                    </HStack>
                                </ListItem>

                                <ListItem>
                                    <HStack align="start">
                                        <ListIcon as={FaCheckCircle} color="orange.500" mt={1} />
                                        <VStack align="start" spacing={1}>
                                            <Text fontWeight="bold">Step 5: Complete Payment</Text>
                                            <Text fontSize="sm" color="gray.600">
                                                After placing your order, you'll receive payment links via email. Complete the payment to confirm your order
                                            </Text>
                                        </VStack>
                                    </HStack>
                                </ListItem>
                            </List>

                            <Box bg="blue.50" p={4} borderRadius="lg" mt={4}>
                                <Text fontSize="sm" color="blue.800" fontWeight="medium">
                                    💡 <strong>Pro Tip:</strong> You can download the QR code for free and use it immediately, or order our premium products for a professional look!
                                </Text>
                            </Box>
                        </VStack>
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* Image Expand Modal */}
            <Modal isOpen={isImageModalOpen} onClose={onImageModalClose} size="3xl" isCentered>
                <ModalOverlay backdropFilter="blur(8px)" />
                <ModalContent bg="transparent" boxShadow="none">
                    <ModalCloseButton color="white" bg="blackAlpha.600" _hover={{ bg: 'blackAlpha.800' }} />
                    <ModalBody p={0}>
                        <Image
                            src={selectedImage}
                            alt={selectedImageTitle}
                            borderRadius="lg"
                            w="full"
                            h="auto"
                            maxH="90vh"
                            objectFit="contain"
                        />
                        <Text
                            textAlign="center"
                            mt={4}
                            fontSize="lg"
                            fontWeight="bold"
                            color="white"
                            textShadow="0 2px 4px rgba(0,0,0,0.5)"
                        >
                            {selectedImageTitle}
                        </Text>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    );
}

export default GenerateQR;